var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import KeyCode from '@core/enums/keycode';
import ScrollLock from "@core/helper/scroll-lock";
import SearchControl from './search-control.vue';
import { LazyModelChoiceFieldEvents } from './enums';
var TCLazyModelChoiceField = /** @class */ (function (_super) {
    __extends(TCLazyModelChoiceField, _super);
    function TCLazyModelChoiceField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.SearchControlType = SearchControlType;
        _this.choices = [];
        _this.searchText = null;
        // The actual selected value that is stored in the form field
        _this.value = null;
        // Properties passed to the actual form field
        _this.inputProperties = {};
        // Private properties
        _this.isExpanded = false;
        // Visually selected value (before pressing enter or clicking an option)
        _this.softSelectedChoice = null;
        // Whether or not the component is loading
        _this.isLoading = false;
        // Whether or not the component is about to start loading
        _this.isSoftLoading = false;
        // timeout handle used to prevent making a request per keystroke
        _this.searchCooldownTimeout = undefined;
        // Total results matching the search query
        _this.totalResults = 0;
        // Max results to display
        _this.maxResults = 0;
        // Whether or not the component has pushed something to the history state
        _this.hasPushedHistoryState = false;
        // Whether or not the current width of the screen is narrow enough to trigger mobile view
        _this.isMobile = false;
        return _this;
    }
    Object.defineProperty(TCLazyModelChoiceField.prototype, "searchControlProps", {
        get: function () {
            return {
                isLoading: this.isLoading,
                disabled: this.disabled,
                readonly: this.readonly,
                required: this.required,
                isExpanded: this.isExpanded,
                isSoftLoading: this.isSoftLoading,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCLazyModelChoiceField.prototype, "searchControlListeners", {
        get: function () {
            return {
                search: this.search,
                focus: this.onSearchInputFocus,
                keydown: this.onSearchInputKeyDown,
                click: this.onSearchInputClick,
                clear: this.clear,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TCLazyModelChoiceField.prototype, "isEmpty", {
        get: function () {
            return this.value == null || this.value.length == 0;
        },
        enumerable: false,
        configurable: true
    });
    TCLazyModelChoiceField.prototype.data = function () {
        return {
            value: this.initialValue
        };
    };
    TCLazyModelChoiceField.prototype.emitGlobalEvent = function (name) {
        window.dispatchEvent(new CustomEvent(name, {
            detail: {
                id: this.id,
                value: this.value
            }
        }));
    };
    TCLazyModelChoiceField.prototype.mounted = function () {
        this.onValueChanged();
        if (this.value) {
            this.loadInitiallySelectedChoice();
        }
        else {
            this.updateChoices();
        }
        document.body.addEventListener('click', this.onBodyClick);
        window.addEventListener('resize', this.onWindowResize);
        this.onWindowResize();
    };
    TCLazyModelChoiceField.prototype.destroyed = function () {
        document.body.removeEventListener('click', this.onBodyClick);
        window.removeEventListener('resize', this.onWindowResize);
    };
    TCLazyModelChoiceField.prototype.onSearchTextChanged = function () {
        var _this = this;
        var selectedChoice = this.choices.find(function (o) { return o.id == _this.value; });
        if (selectedChoice == null || this.searchText != selectedChoice.label) {
            this.isSoftLoading = true;
            clearTimeout(this.searchCooldownTimeout);
            this.searchCooldownTimeout = setTimeout(function () { return _this.updateChoices(true); }, 500);
        }
    };
    TCLazyModelChoiceField.prototype.onIsLoadingChanged = function () {
        this.isSoftLoading = this.isLoading;
    };
    TCLazyModelChoiceField.prototype.onValueChanged = function () {
        var _this = this;
        this.softSelectedChoice = this.choices.find(function (o) { return o.id == _this.value; });
        var ignoredPropertyNames = [
            'url', 'initialValue',
        ];
        this.inputProperties.value = this.value ? this.value : null;
        for (var propertyName in this.$props) {
            if (ignoredPropertyNames.indexOf(propertyName)) {
                this.inputProperties[propertyName] = this.$props[propertyName];
            }
        }
        if (this.value != this.initialValue) {
            this.emitGlobalEvent(LazyModelChoiceFieldEvents.ValueChanged);
        }
    };
    TCLazyModelChoiceField.prototype.onSoftSelectedChoiceChanged = function () {
        if (this.isExpanded) {
            this.ensureSoftSelectedChoiceVisible();
        }
    };
    TCLazyModelChoiceField.prototype.onIsExpandedChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var onPopState_1;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isExpanded) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.$nextTick()];
                    case 1:
                        _b.sent();
                        this.ensureSoftSelectedChoiceVisible();
                        // choices
                        if (this.isMobile) {
                            ScrollLock.setEnabled(true);
                            this.$router.push({
                                query: (_a = {},
                                    _a["".concat(this.id, "-is-open")] = '1',
                                    _a),
                            });
                            this.hasPushedHistoryState = true;
                            onPopState_1 = function () {
                                _this.hasPushedHistoryState = false;
                                _this.isExpanded = false;
                                window.removeEventListener('popstate', onPopState_1);
                            };
                            window.addEventListener('popstate', onPopState_1);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        ScrollLock.setEnabled(false);
                        if (this.hasPushedHistoryState) {
                            this.hasPushedHistoryState = false;
                            history.back();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TCLazyModelChoiceField.prototype.onWindowResize = function () {
        this.isMobile = window.innerWidth <= 768;
    };
    TCLazyModelChoiceField.prototype.onBodyClick = function (e) {
        var element = e.target;
        if (element != this.$el && !this.$el.contains(element)) {
            this.isExpanded = false;
        }
    };
    TCLazyModelChoiceField.prototype.onSearchInputFocus = function (e, type) {
        this.isExpanded = true;
    };
    // Clicking the search input shows the choices list
    TCLazyModelChoiceField.prototype.onSearchInputClick = function () {
        this.isExpanded = true;
    };
    TCLazyModelChoiceField.prototype.onSearchInputKeyDown = function (e) {
        var _this = this;
        // No actions if not expanded
        if (!this.isExpanded) {
            return;
        }
        var currentIndex = this.softSelectedChoice ? this.choices.findIndex(function (o) { return o.id == _this.softSelectedChoice.id; }) : -1;
        switch (e.keyCode) {
            // Enter = select current  option
            case KeyCode.Enter:
                // Prevent default to avoid submitting form when the list is visible
                if (this.isExpanded) {
                    e.preventDefault();
                }
                // Quick fix for the Enter issue - Force option change detection
                if (this.softSelectedChoice != null) {
                    this.select(this.softSelectedChoice);
                }
                break;
            // Down = move selection down by one
            case KeyCode.DownArrow:
                if (currentIndex < this.choices.length - 1) {
                    this.softSelectedChoice = this.choices[currentIndex + 1];
                }
                else {
                    this.softSelectedChoice = this.choices[0];
                }
                // Prevent caret navigation
                e.preventDefault();
                break;
            // Up = move selection up by one
            case KeyCode.UpArrow:
                if (currentIndex > 0) {
                    this.softSelectedChoice = this.choices[currentIndex - 1];
                }
                else {
                    this.softSelectedChoice = this.choices[this.choices.length - 1];
                }
                // Prevent caret navigation
                e.preventDefault();
                break;
            case KeyCode.Escape:
                this.isExpanded = false;
                break;
        }
    };
    TCLazyModelChoiceField.prototype.loadInitiallySelectedChoice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        url = "".concat(this.url, "?pk=").concat(encodeURIComponent(this.value || ''));
                        return [4 /*yield*/, fetch(url).then(function (res) { return res.json(); })];
                    case 1:
                        result = _b.sent();
                        _a = [result.choices, result.max_results, result.total_results], this.choices = _a[0], this.maxResults = _a[1], this.totalResults = _a[2];
                        if (this.choices.length > 0) {
                            this.searchText = this.choices[0].label;
                        }
                        else {
                            console.warn("Failed to load initially selected value for field \"".concat(this.id, "\" with value \"").concat(this.value, "\"!"), result);
                        }
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TCLazyModelChoiceField.prototype.updateChoices = function (expand) {
        if (expand === void 0) { expand = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        url = "".concat(this.url, "?query=").concat(encodeURIComponent(this.searchText || ''));
                        return [4 /*yield*/, fetch(url).then(function (res) { return res.json(); })];
                    case 1:
                        result = _b.sent();
                        _a = [result.choices, result.max_results, result.total_results], this.choices = _a[0], this.maxResults = _a[1], this.totalResults = _a[2];
                        this.isLoading = false;
                        if (expand) {
                            this.isExpanded = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TCLazyModelChoiceField.prototype.select = function (choice) {
        this.isExpanded = false;
        this.value = choice.id;
        this.searchText = choice.label;
    };
    // Ensures a choice is visible on the screen (scrollY)
    TCLazyModelChoiceField.prototype.ensureSoftSelectedChoiceVisible = function () {
        if (!this.softSelectedChoice) {
            return;
        }
        var option = this.$refs.autoCompleteOptions[this.choices.indexOf(this.softSelectedChoice)];
        // User searched and current option is no longer available
        if (option == null) {
            return;
        }
        var listTop = this.$refs.autoCompleteListWrapper.scrollTop;
        var listBottom = listTop + this.$refs.autoCompleteListWrapper.clientHeight;
        var optionTop = option.offsetTop;
        var optionBottom = optionTop + option.clientHeight;
        if (optionBottom >= listBottom) {
            this.$refs.autoCompleteListWrapper.scrollTop = option.offsetTop - this.$refs.autoCompleteListWrapper.clientHeight + option.clientHeight;
        }
        else if (optionTop <= listTop) {
            this.$refs.autoCompleteListWrapper.scrollTop = option.offsetTop;
        }
    };
    TCLazyModelChoiceField.prototype.search = function () {
        this.isExpanded = false;
    };
    TCLazyModelChoiceField.prototype.clear = function () {
        this.value = null;
        if (this.searchText != null) {
            this.searchText = null;
            this.updateChoices();
        }
    };
    __decorate([
        Prop({ type: String })
    ], TCLazyModelChoiceField.prototype, "id", void 0);
    __decorate([
        Prop({ type: String })
    ], TCLazyModelChoiceField.prototype, "type", void 0);
    __decorate([
        Prop({ type: String })
    ], TCLazyModelChoiceField.prototype, "name", void 0);
    __decorate([
        Prop({ type: String })
    ], TCLazyModelChoiceField.prototype, "url", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCLazyModelChoiceField.prototype, "required", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCLazyModelChoiceField.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], TCLazyModelChoiceField.prototype, "readonly", void 0);
    __decorate([
        Prop()
    ], TCLazyModelChoiceField.prototype, "initialValue", void 0);
    __decorate([
        Watch('searchText')
    ], TCLazyModelChoiceField.prototype, "onSearchTextChanged", null);
    __decorate([
        Watch('isLoading')
    ], TCLazyModelChoiceField.prototype, "onIsLoadingChanged", null);
    __decorate([
        Watch('value')
    ], TCLazyModelChoiceField.prototype, "onValueChanged", null);
    __decorate([
        Watch('softSelectedChoice')
    ], TCLazyModelChoiceField.prototype, "onSoftSelectedChoiceChanged", null);
    __decorate([
        Watch('isExpanded')
    ], TCLazyModelChoiceField.prototype, "onIsExpandedChanged", null);
    TCLazyModelChoiceField = __decorate([
        Component({ components: { SearchControl: SearchControl } })
    ], TCLazyModelChoiceField);
    return TCLazyModelChoiceField;
}(Vue));
export default TCLazyModelChoiceField;
export var SearchControlType;
(function (SearchControlType) {
    SearchControlType["Primary"] = "primary";
    SearchControlType["Modal"] = "modal";
})(SearchControlType || (SearchControlType = {}));
